import { render, staticRenderFns } from "./PosBanner.vue?vue&type=template&id=1edb9de2&scoped=true"
import script from "./PosBanner.vue?vue&type=script&lang=js"
export * from "./PosBanner.vue?vue&type=script&lang=js"
import style0 from "./PosBanner.vue?vue&type=style&index=0&id=1edb9de2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1edb9de2",
  null
  
)

export default component.exports